import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { DocumentacionForm } from "./form";
import { createSelectorRx } from "keautils";

const DocumentacionFormRx = componentToRx(DocumentacionForm);
type Entity = models.Documentacion;
const resource = resources.Documentacion;

interface Props {
    match: match<{ id: string }>
}

class DocumentacionEditComp extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
    }

    id = (props: Props) => Number.parseInt(props.match.params.id);
    value = createSelectorRx(this.id, id => resource.Get(id));

    render() {
        const props = this.props;
        const value = this.value(props);
        return <DocumentacionFormRx value={value} />;
    }
}

export const DocumentacionEdit = withRouter(DocumentacionEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/documentacion/edit/edit.tsx